import '../plugins/scroll-to-anchor'

$.fn.VegetableMenu = function(offset = 0) {
  let self = this

  self.find('.vegetable-menu__toggle').click(function() {
    self.toggleClass('--open');
  })

  self.find('button[href^=#]').each(function() {
    $(this).scrollToAnchor()
  })

  $('body').click(function(e) {
    if ($(e.target).closest('.vegetable-menu').length == 0) {
      self.removeClass('--open')
    }
  });

  $('.vegetable-menu__anchors__item').click(function(e) {
    self.removeClass('--open')
  });

  return function() {
    return self
  }()
};
